import { tryCatchHelper } from '../../../helpers';
import {
  ACTIVO_MATRICULAS,
  ALL_MATRICULAS,
  LOADING_ALL_MATRICULAS,
} from './MatriculasReducer';
import {
  allMatriculasService,
  deleteMatriculasService,
  oneMatriculasService,
  saveMatriculasService,
} from './MatriculasService';
import { ALL_MAT_SECCIONES } from './mat_secciones/MatSeccionesReducer';

export const allMatriculasAction = async (dispatch, params) => {
  try {
    dispatch({ type: LOADING_ALL_MATRICULAS, payload: true });
    const res = await allMatriculasService(params);
    dispatch({ type: ALL_MATRICULAS, payload: res.data });
    dispatch({ type: LOADING_ALL_MATRICULAS, payload: false });
    return res.data;
  } catch (e) {
    dispatch({ type: LOADING_ALL_MATRICULAS, payload: false });
    tryCatchHelper(e);
    return false;
  }
};

export const saveMatriculasAction = async (
  { dispatch, notify, isAlert = true },
  id,
  data,
  params,
) => {
  try {
    const res = await saveMatriculasService(id, data);
    if (isAlert) notify(res.data.message);
    await allMatriculasAction(dispatch, params);
    return res.data;
  } catch (e) {
    tryCatchHelper({ e, notify });
    return false;
  }
};

export const setActivoMatriculasAction = async (dispatch, data) => {
  dispatch({ type: ACTIVO_MATRICULAS, payload: data });
  if (data) {
    dispatch({ type: ALL_MAT_SECCIONES, payload: data.secciones });
  }
};

export const oneMatriculasAction = async (dispatch, id) => {
  try {
    const res = await oneMatriculasService(id);
    await setActivoMatriculasAction(dispatch, res.data.data);
    return res.data;
  } catch (e) {
    tryCatchHelper(e);
    return false;
  }
};

export const deleteMatriculasAction = async (
  { dispatch, notify },
  id,
  params,
) => {
  try {
    const res = await deleteMatriculasService(id);
    notify(res.data.message);
    await setActivoMatriculasAction(dispatch, null);
    await allMatriculasAction(dispatch, params);
    return res.data;
  } catch (e) {
    tryCatchHelper({ e, notify });
    return false;
  }
};
